import { useQuery } from 'react-query'
import { OrganizationEditModalForm } from './OrganizationEditModalForm'

const OrganizationAddModalFormWrapper = (props: any) => {
    return <OrganizationEditModalForm modelHideshow={props.modelHideshow} fetchorganizationsList={props.fetchorganizationsList} />
}

export { OrganizationAddModalFormWrapper }
